import React, { useContext } from 'react';
import { Heading } from '@thd-olt-component-react/core-ui';
import classNames from 'classnames/bind';
import { FBTContext } from '../contexts/FBTContext';
import { FBTPlaceholder } from '../FBTPlaceholder.component';
import { RecsPropductPod } from './RecsPropductPod';
import {
  getImageURL,
} from '../helpers/helpers';
import styles from '../thd-recs-fbt.module.scss';

const cx = classNames.bind(styles);
export const RecsFBT = () => {

  const {
    RecsFbtResponseData,
    RecsFbtResponseDataLoading,
    productResponseData,
    productResponseLoading,
    checkedItems
  } = useContext(FBTContext);

  const product = productResponseData?.product;
  if (productResponseLoading || RecsFbtResponseDataLoading) {
    return (
      <FBTPlaceholder />
    );
  }
  if (!product) return null;
  const bundleProducts = RecsFbtResponseData?.recs?.products;
  if (!bundleProducts?.length) return null;
  const normalizeSkus = ({ products }) => {
    return products.map((productObj, productIndex) => {
      // primary item is a frontEnd model response
      const {
        idStartDate,
        idEndDate,
        idPromoDetails,
        category,
        description,
        isAnchor,
        product: {
          identifiers: {
            canonicalUrl: canonicalURL,
            itemId,
            brandName,
            productLabel
          },
          badges,
          pricing,
          media: {
            images
          },
          reviews
        }
      } = productObj;

      const averageRating = reviews?.ratingsReviews?.averageRating;
      const totalReviews = reviews?.ratingsReviews?.totalReviews;

      // ssr should check the first item
      const checked = typeof window === 'undefined' && productIndex === 0
        ? true
        : (checkedItems.indexOf(itemId) > -1);

      if (productIndex === 0) {
        const image = images?.find((i) => i.subType === 'PRIMARY');
        const imageURL = image ? image.url : '';
        return {
          brand: brandName,
          canonicalURL,
          badges,
          pricing,
          idStartDate,
          idEndDate,
          idPromoDetails,
          category,
          itemId,
          productName: productLabel,
          rating: averageRating,
          reviews: totalReviews,
          imageURL,
          checked,
          product: productObj.product,
          type: 'primary'
        };
      }
      return {
        brand: brandName,
        canonicalURL,
        badges,
        pricing,
        productName: productLabel,
        rating: averageRating,
        reviews: totalReviews,
        imageURL: getImageURL(images),
        itemId,
        idPromoDetails,
        category,
        description,
        isAnchor,
        checked,
        product: productObj.product,
        type: 'product'
      };
    });
  };
  const normalizedProducts = normalizeSkus({ products: [{ product }, ...bundleProducts] });

  return (
    <>
      <div className={cx('frequently-bought-together')} data-type="container">
        <meta data-prop="name" content="pip_fbt" />
        <Heading title="Frequently Bought Together" underline />
        <RecsPropductPod normalizedProducts={normalizedProducts} product={product} />
      </div>
    </>
  );
};

RecsFBT.propTypes = {

};

RecsFBT.defaultProps = {

};
